import React from "react";

/** Inline SVGs — single stroke style, matches landing palette */
export function IvIcon({ name, className = "" }) {
  const cn = `ivlp-icon-svg ${className}`.trim();
  const stroke = "currentColor";
  const props = { className: cn, width: 28, height: 28, viewBox: "0 0 24 24", fill: "none", stroke, strokeWidth: 1.65, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": true };

  switch (name) {
    case "spark":
      return (
        <svg {...props}>
          <path d="M12 3v3M12 18v3M3 12h3M18 12h3" />
          <path d="M12 8a4 4 0 1 0 4 4 4 4 0 0 0-4-4Z" opacity="0.35" />
          <path d="m12 6 1.6 3.6L17 12l-3.4 2.4L12 18l-1.6-3.6L7 12l3.4-2.4L12 6Z" />
        </svg>
      );
    case "shield":
      return (
        <svg {...props}>
          <path d="M12 3 5 6v6c0 5 3.5 8 7 9 3.5-1 7-4 7-9V6l-7-3Z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      );
    case "path":
      return (
        <svg {...props}>
          <path d="M4 18c3-6 6-9 12-12" />
          <circle cx="4" cy="18" r="2" fill="currentColor" stroke="none" opacity="0.25" />
          <circle cx="16" cy="6" r="2" fill="currentColor" stroke="none" />
        </svg>
      );
    case "pen":
      return (
        <svg {...props}>
          <path d="M12 20h9" />
          <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5Z" />
        </svg>
      );
    case "steps":
      return (
        <svg {...props}>
          <circle cx="6" cy="18" r="2.5" />
          <circle cx="12" cy="12" r="2.5" />
          <circle cx="18" cy="6" r="2.5" />
          <path d="m8 16.5 4-3.5M14 10.5l4-3.5" opacity="0.45" />
        </svg>
      );
    case "chatOff":
      return (
        <svg {...props}>
          <path d="M8.5 9h7M9 13h3.5" />
          <path d="m3 3 18 18" />
          <path d="M5 18H3v-7l2-2V5h13" opacity="0.4" />
        </svg>
      );
    case "phone":
      return (
        <svg {...props}>
          <rect x="7" y="3" width="10" height="18" rx="2.5" />
          <path d="M10 7h4M10 18h4" opacity="0.45" />
        </svg>
      );
    case "map":
      return (
        <svg {...props}>
          <path d="M9 18 3 15V5l6 3 6-3 6 3v10l-6 3-6-3Z" />
          <path d="m9 18 6-3" opacity="0.45" />
        </svg>
      );
    case "people":
      return (
        <svg {...props}>
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      );
    case "mind":
      return (
        <svg {...props}>
          <path d="M12 5a3 3 0 0 0-3 3v1a3 3 0 0 0 6 0V8a3 3 0 0 0-3-3Z" />
          <path d="M6 11h-.5A2.5 2.5 0 0 0 3 13.5V15a2 2 0 0 0 2 2h1" />
          <path d="M18 11h.5A2.5 2.5 0 0 1 21 13.5V15a2 2 0 0 1-2 2h-1" />
          <path d="M9 19h6" opacity="0.45" />
        </svg>
      );
    case "pulse":
      return (
        <svg {...props}>
          <path d="M4 12h3l2-6 4 12 2-6h5" />
        </svg>
      );
    case "heart":
      return (
        <svg {...props}>
          <path d="M19 14c1.5-1.5 2-3.5 2-5.5A5.5 5.5 0 0 0 8.5 6 4 4 0 0 0 5 14c3 4 7 6 7 6s4-2 7-6Z" />
        </svg>
      );
    case "moon":
      return (
        <svg {...props}>
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" />
        </svg>
      );
    case "anchor":
      return (
        <svg {...props}>
          <circle cx="12" cy="5" r="2" />
          <path d="M12 7v13M9 20h6M5 15l3-3M19 15l-3-3" />
        </svg>
      );
    case "link":
      return (
        <svg {...props}>
          <path d="M10 13a5 5 0 0 1 0-7l1-1a5 5 0 0 1 7 7l-1 1" />
          <path d="M14 11a5 5 0 0 1 0 7l-1 1a5 5 0 0 1-7-7l1-1" />
        </svg>
      );
    case "sun":
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="3.5" />
          <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" opacity="0.45" />
        </svg>
      );
    case "compass":
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="9" />
          <path d="m12 7 2.2 5 4.8.6-4.8.6L12 19l-2.2-5-4.8-.6 4.8-.6L12 7Z" />
        </svg>
      );
    case "sprout":
      return (
        <svg {...props}>
          <path d="M12 22v-6M12 16c-3 0-5-2-5-5 3 0 5 2 5 5Z" />
          <path d="M12 16c3 0 5-2 5-5-3 0-5 2-5 5Z" opacity="0.45" />
        </svg>
      );
    case "layers":
      return (
        <svg {...props}>
          <path d="m12 3 9 5-9 5-9-5 9-5Z" />
          <path d="m3 12 9 5 9-5M3 17l9 5 9-5" opacity="0.45" />
        </svg>
      );
    case "wave":
      return (
        <svg {...props}>
          <path d="M4 12c2-3 4-3 6 0s4 3 6 0 4-3 6 0" />
          <path d="M4 16c2-3 4-3 6 0s4 3 6 0 4-3 6 0" opacity="0.45" />
        </svg>
      );
    default:
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="8" />
        </svg>
      );
  }
}
